// <s-thumb-gallery>: swaps the visible stage slide when a thumbnail button sends the --show command.
class SThumbGallery extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', (event) => {
      if (event.command !== '--show') return;
      const index = Number(event.source?.dataset.index ?? 0);
      this.#show(index);
    }, { signal: this.#ac.signal });

    // Scrolling thumbnail strip: 6 visible, arrows only when there are more (and only on the side that has more).
    const track = this.querySelector('[data-thumb-track]');
    if (!track) return;
    this.#track = track;
    const arrows = this.querySelectorAll('[data-thumb-arrow]');
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      arrows.forEach((a) => { a.hidden = a.dataset.thumbArrow === '-1' ? track.scrollLeft <= 1 : track.scrollLeft >= max; });
    };
    arrows.forEach((a) => a.addEventListener('click', () => {
      track.scrollBy({ left: Number(a.dataset.thumbArrow) * track.clientWidth, behavior: 'smooth' });
    }, { signal: this.#ac.signal }));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true, signal: this.#ac.signal });
    window.addEventListener('resize', sync, { signal: this.#ac.signal });
    sync();
  }

  #track;

  // Keep the chosen thumbnail inside the strip without moving the page.
  #reveal(thumb) {
    const track = this.#track;
    if (!track || !thumb) return;
    const left = thumb.offsetLeft - track.offsetLeft;
    if (left < track.scrollLeft) track.scrollTo({ left, behavior: 'smooth' });
    else if (left + thumb.offsetWidth > track.scrollLeft + track.clientWidth) track.scrollTo({ left: left + thumb.offsetWidth - track.clientWidth, behavior: 'smooth' });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #show(index) {
    const slides = this.querySelectorAll('[data-slide]');
    const thumbs = this.querySelectorAll('[data-thumb]');
    const current = this.querySelector('[data-slide]:not([hidden])');
    const next = slides[index];
    if (!next || next === current) return;
    this.#reveal([...thumbs].find((t) => t.dataset.index === String(index)));

    const swap = () => {
      slides.forEach((slide) => { slide.hidden = slide !== next; });
      thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb.dataset.index === String(index))));
    };

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !current) {
      swap();
      return;
    }
    next.hidden = false;
    current.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 150, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }).finished.then(swap, swap);
  }
}

if (!customElements.get('s-thumb-gallery')) customElements.define('s-thumb-gallery', SThumbGallery);
